import { Component, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.css"],
    providers: [ MatDividerModule, MatButtonModule ],
    standalone: true,
})
export class LoginComponent implements OnInit {

  ngOnInit() {
    this.auth();
  }

  public auth(){
    window.open(environment.auth.ssoPdpj, '_self')
  }

}
